import React from 'react'
import PropTypes from 'prop-types'
import {
  StyledCardNews,
  StyledListContainer,
  StyledListWithPagination,
} from './ListWithPagination.styled'
import ListType from '../../enums/ListType'
import NewsPaginator from '../NewsPaginator/NewsPaginator'

const CTA_CARD_LABEL = 'Continue reading'

const ListWithPagination = (props) => {
  const {
    className,
    type,
    currentPage,
    currentList,
    count,
    onClickLink,
    parameters,
    setParameters,
  } = props

  const cardsList =
    currentList &&
    currentList.map((element) => {
      if (type === ListType.news) {
        return (
          <StyledCardNews
            backgroundColor={element?.node.backgroundColor}
            date={element?.node.date}
            category={element?.node.categories[0].name}
            ctaCardLabel={CTA_CARD_LABEL}
            description={element?.node.seoMetaDescription?.seoMetaDescription}
            image={element?.node.image}
            key={element.node.id}
            slug={element.node.slug}
            imageHeaderDesktop={element.node.imageHeaderDesktop}
            imageHeaderMobile={element.node.imageHeaderMobile}
            thumbnail={element.node.thumbnail}
            title={element.node.title}
          />
        )
      }
      return null
    })

  return (
    <StyledListWithPagination className={className}>
      <StyledListContainer>{cardsList}</StyledListContainer>
      {count > 1 && (
        <NewsPaginator
          count={count}
          currentPage={currentPage}
          onClickLink={onClickLink}
          parameters={parameters}
          setParameters={setParameters}
        />
      )}
    </StyledListWithPagination>
  )
}

ListWithPagination.propTypes = {
  className: PropTypes.string,
  list: PropTypes.array,
  type: PropTypes.string.isRequired,
  urlParams: PropTypes.object,
}

export default ListWithPagination
